import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { ContextPermissionsProvider } from "./context/contextPermissions";
import jwtDecode from "./utils/jwtDecode";

import "./App.css";
import Routes from "./rooting/routes";

function App() {
  const [curPermissions, setCurPermissions] = useState({
    upload_panel: false,
    admin_panel: false,
    studies_details: false,
  });

  const { isLoading, isAuthenticated, getAccessTokenSilently, logout } =
    useAuth0();

  useEffect(() => {
    async function init() {
      try {
        const jwt = await getAccessTokenSilently();
        var token = jwtDecode(jwt);
        var allPermissions = token.permissions;
        var userNameArray = token["https://dev.llh-wow.com/roles"];

        var userName = "";
        if (
          userNameArray[0].indexOf("admin") == -1 &&
          userNameArray[0].indexOf("regular-client") == -1 &&
          userNameArray[0].indexOf("super-client") &&
          -1
        ) {
          userName = userNameArray[0];
        } else {
          userName = userNameArray[1];
        }

        var curPermissionsClone = { ...curPermissions };
        allPermissions.map((permission) => {
          var curPermission = permission.split(":");
          if (curPermission[0] == "access") {
            curPermissionsClone[curPermission[1]] = true;
          }
        });
        curPermissionsClone.username = userName;
        setCurPermissions(curPermissionsClone);

        // setLoading(false);
      } catch (ex) {
        console.log("ex", ex);
      }
    }
    init();
  }, [setCurPermissions]);

  return (
    <>
      <ContextPermissionsProvider permissions={curPermissions}>
        <Routes />
      </ContextPermissionsProvider>
    </>
  );
}
export default App;
